"use client";
import { useEffect, useState } from "react";
import { evaluateFeatureFlag } from "../evaluateFeatureFlag";
import type { FlagMap } from "../types";

function useFeatureFlag<K extends keyof FlagMap>(
  flagKey: K,
  fallback?: FlagMap[K],
) {
  const [flagValue, setFlagValue] = useState<FlagMap[K] | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFeatureFlag = async () => {
      try {
        const value = (await evaluateFeatureFlag(
          flagKey,
          fallback || "",
        )) as FlagMap[K];
        setFlagValue(value);
      } catch (error) {
        console.error("Error fetching feature flag:", error);
        // If there's an error, use the fallback if provided
        if (fallback) {
          setFlagValue(fallback);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchFeatureFlag();
  }, [flagKey, fallback]);

  return { flagValue, isLoading };
}

export default useFeatureFlag;
